import {decorate, observable} from 'mobx';
import {faTools} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';
import {makeFormFields} from '../components/shared/form/formFields';
import {KeyValueArray} from './keyValueTransforms';

export class MesConfig extends BaseModel {
  static faIcon = faTools;
  nestedModels = ['modules', 'corporateIdentity', 'mqtt'];

  static prepareApiPayload(model) {
    return {
      modules: model.modules,
      language: model.language,
      logoutAfterInactivity: model.logoutAfterInactivity,
      enableExperimental: model.enableExperimental,
      corporateIdentity: model.corporateIdentity,
      mqtt: model.mqtt,
      interruptionTags: model.interruptionTags,
    };
  }

  getFormFields() {
    const {interruptionTags, ...rest} = this;
    return [
      ...makeFormFields(rest),
      {name: 'interruptionTags', value: KeyValueArray(interruptionTags)},
    ];
  }
}

decorate(MesConfig, {
  modules: observable,
  interruptionTags: observable,
  language: observable,
  logoutAfterInactivity: observable,
  corporateIdentity: observable,
  enableExperimental: observable,
  mqtt: observable,
});
